import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Icon, List, Popup } from "semantic-ui-react";
import "./actions.css";
import { Action } from "./types";

type ActionMenuProps = {
	actions: Action[];
};

const ActionsMenu = ({ actions }: ActionMenuProps) => {
	const [open, setOpen] = useState(false);

	return (
		<Popup
			basic
			className="actionsPopup"
			trigger={<Icon className="actionsTrigger" style={{ cursor: "pointer" }} name="ellipsis horizontal" />}
			on="click"
			open={open}
			onOpen={() => setOpen(true)}
			onClose={() => setOpen(false)}
		>
			<div onClick={() => setOpen(false)}>
				<List selection verticalAlign="middle">
					{actions.map((ac) => {
						if (!ac.hasArea) return null;

						if ("to" in ac) {
							return (
								<List.Item key={ac.to} as={Link} to={ac.to} target="_blank">
									<Icon className={ac.icon} />
									<List.Content>{ac.title}</List.Content>
								</List.Item>
							);
						} else if ("component" in ac) {
							return <React.Fragment key={crypto.randomUUID()}>{ac.component(true)}</React.Fragment>;
						} else {
							console.warn("Unsupported action in ActionsMenu", ac);
						}

						return null;
					})}
				</List>
			</div>
		</Popup>
	);
};

export default ActionsMenu;
